import { LiteralUnion } from "material-react-table";
import {
  DetailedServiceBookableEquipment,
  DetailedServiceCatering,
  DetailedServiceRoomLayout
} from "./RemoteOrderRequests.types";

export enum SortOrder {
  DateAscending = "date-ascending", // Earliest
  DateDescending = "date-descending", // Most recent
  NameAscending = "name-ascending", // A to Z
  NameDescending = "name-descending" // Z to A
}

export type OrderRequestCateringRow = DetailedServiceCatering;

export type OrderRequestCateringRowValues = Record<
  LiteralUnion<
    | "id"
    | "name"
    | "image"
    | "description"
    | "pricePerUnit"
    | "quantity"
    | "orderedQty"
    | "availableQty"
    | "status"
    | "deliveryStatus"
    | "setupTime"
    | "bookingLeadTime"
  >,
  any
>;

export type OrderRequestBookableEquipmentRow = DetailedServiceBookableEquipment;

export type OrderRequestBookableEquipmentRowValues = Record<
  LiteralUnion<
    | "id"
    | "name"
    | "image"
    | "description"
    | "category"
    | "costPerHour"
    | "quantity"
    | "status"
    | "deliveryStatus"
    | "setupTime"
    | "bookingLeadTime"
  >,
  any
>;

export type OrderRequestRoomLayoutRow = DetailedServiceRoomLayout & { layout: Array<boolean[]> };

export type OrderRequestRoomLayoutRowValues = Record<
  LiteralUnion<
    | "id"
    | "name"
    | "quantity"
    | "status"
    | "deliveryStatus"
    | "setupTime"
    | "layout"
    | "picturePaths"
  >,
  any
>;
